<!--
 * @Description: file content
 * @Author: yangsibo
 * @Date: 2022-06-06 09:39:33
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-08 08:35:52
 * @FilePath: \YunYin_admin\src\views\Village\SetQuery\Base.vue
-->
<template>
  <el-main class="base">
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <div class="title-wrap vertical-line">
        <h2 class="title">
          <span class="txt" style="font-size: 16px">{{
            villageInfo.fullName
          }}</span>
        </h2>
      </div>
      <el-descriptions
        class="margin-top"
        title=""
        :column="3"
        :size="size"
        border
      >
        <el-descriptions-item>
          <template slot="label"> 省市县乡镇村 </template>
          {{ villageInfo.address }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 村集体全称 </template>
          {{ villageInfo.fullName }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 村集体简称 </template>
          {{ villageInfo.shortName }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 联系人 </template>
          {{ villageInfo.personName }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 电话 </template>
          {{ villageInfo.phone }}
        </el-descriptions-item>
      </el-descriptions>
      <div class="title-wrap vertical-line">
        <h2 class="title">
          <span class="txt" style="font-size: 16px">地图位置</span>
        </h2>
      </div>
      <LandMap
        :mapTopInfoOptions="mapTopInfoOptions"
        :trajectoryList="[]"
        :markerInfo="markerInfo"
      ></LandMap>
    </div>
  </el-main>
</template>

<script>
import LandMap from "@/components/LandMap";
import { mapActions } from "vuex";
export default {
  name: "Base",
  data() {
    return {
      size: "",
      mapTopInfoOptions: {
        hasAll: true,
        isFilter: true,
        data: [],
        hasData: true,
      },
      villageInfo: "",
      markerInfo: {},
    };
  },
  components: { LandMap },
  filters: {},
  watch: {},
  created() {
    let { $businessId } = this.$route.query;
    this.getVillageById($businessId);
    this.changeShowTrajectory(false);
  },
  mounted() {},
  methods: {
    ...mapActions({
      changeShowTrajectory: "map/changeShowTrajectory",
    }),
    /**
     * @description: 获取村集体基础信息
     * @Author: yangsibo
     * @Date: 2022-06-07 15:30:35
     * @param {*} villageId 村集体id
     */
    async getVillageById(villageId) {
      try {
        let { data } = await this.$http.village.getVillageById({ villageId });
        this.villageInfo = data;
        if (data.centre) {
          let centre = data.centre ? data.centre.split(",") : [];
          this.markerInfo = {
            longitude: centre[0],
            latitude: centre[1],
          };
        }
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";
.base {
  .title-wrap {
    @include plate-title-mutil;
    border-bottom: none;
    .txt {
      font-size: 16px;
    }
  }
  ::v-deep .el-descriptions {
    .el-descriptions__body .el-descriptions__table .el-descriptions-item__cell {
      text-align: center;
    }
  }
}
</style>
